import Page from 'components/layout/Page';
import { Heading1 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import RolesCategory from './RolesCategory';
import {
  StyledContainer,
  StyledHeader,
  StyledRoles
} from './RolesComponent.styled';

type Role = {
  name: string;
  desc: string;
};

type RoleCategory = {
  id: string;
  category: string;
  roles: Array<Role>;
};

type RolesComponentProps = {
  roles: Array<RoleCategory>;
};

const RolesComponent: React.FC<RolesComponentProps> = ({ roles }) => {
  const { t } = useI18n('roles');

  return (
    <Page hasScrollTop>
      <StyledContainer>
        <StyledHeader>
          <Heading1 editorial>{t('title')}</Heading1>
          <p>{t('description')}</p>
        </StyledHeader>
        <StyledRoles>
          {roles.map((r, i) => (
            <RolesCategory key={i} role={r} />
          ))}
        </StyledRoles>
      </StyledContainer>
    </Page>
  );
};

export default RolesComponent;
